// external

// internal
import htmlSerializer from './src/htmlSerializer';
import replace from './src/replace';
import getHrefLangs from './src/getHrefLangs';
import queryAll from './src/queryAll';

import translate from './src/translate';
import Format from './src/format';

async function app ({app, redirect}, inject) {

    // Translate
    app.context.$translate = translate;
    inject('translate', translate);
    
    // Format
    app.context.$format = Format;
    inject('format', Format);

    // Helpers...? 

    if(process.client) {
        window.addEventListener('click', event => {
            if(!event.target.matches('a[data-nuxt-link')) {
                return;
            }
            event.preventDefault();
            redirect(event.target.pathname);
    
        }, false);
    }
}

export default app;
export { htmlSerializer, replace, getHrefLangs, queryAll, Format, translate };